module.exports = __webpack_public_path__ + "static/media/S_E01.3b4486cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/S_E01.png
// module id = 11
// module chunks = 0